import type { ReactNode } from "react"
import { useTranslate } from "@core/hooks/useTranslate"
import { cn } from "@core/utils/cn"

type ReadOnlyWrapperProps = {
  children: ReactNode
  className?: string
}

export const ReadOnlyWrapper = ({ children, className }: ReadOnlyWrapperProps) => {
  const { t } = useTranslate("workspace")

  return (
    <div
      className={cn("relative cursor-not-allowed", className)}
      title={t("subscription.read-only-tooltip")}
    >
      <div className="pointer-events-none opacity-50 select-none">
        {children}
      </div>
    </div>
  )
}
